import { render, staticRenderFns } from "./emitFaceattributeediting.vue?vue&type=template&id=165ba7c6&scoped=true"
import script from "./emitFaceattributeediting.vue?vue&type=script&lang=js"
export * from "./emitFaceattributeediting.vue?vue&type=script&lang=js"
import style0 from "./emitFaceattributeediting.vue?vue&type=style&index=0&id=165ba7c6&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165ba7c6",
  null
  
)

export default component.exports